export const TEST_IDS = {
  MATCHING_LABEL_SKELETON: 'matching-label-skeleton'
};